/* eslint-disable react/no-unused-prop-types */
/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { ChangeEvent, Fragment, KeyboardEvent, useEffect, useRef, useState } from "react";
import { ArrowUpIcon, BadgeInfoIcon, EllipsisIcon, LightbulbIcon, Loader2, Menu, Plus, Trash2Icon } from "lucide-react";
import Markdown from "markdown-to-jsx";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import { useRouter } from "next/router";
import { Button } from "../ui/button";
import { Sheet, SheetContent, SheetHeader } from "../ui/sheets";
import { Input } from "../ui/input";
import { Skeleton } from "../ui/skeleton";
import CortexService from "../../services/cortex/cortex.service";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown";
import { RootState } from "../../store/reducers";
import { cn } from "../../lib/utils";
import { Dialog, DialogContent, DialogFooter } from "../ui/dialog";
import ThreeDotLoader2 from "../loader/three-dots-loader";
import useSnackbar from "../../hooks/useSnackbar";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";
import { mapCrmAdditionalFields } from "../../utils/helper";

type Props = {
  open: boolean;
  setOpen: (val: boolean) => void;
  filters: {[key:string]: any};
  handleThreadFiltersApply: (filter: {[key:string]: any}) => void
}

type ThreadDetail = {
  qid: string;
  query: string;
  final_answer: string;
  completed_at: string;
}

const QueryEngineSheet = ({ open, setOpen, filters, handleThreadFiltersApply }: Props) => {
  const { asPath } = useRouter();
  const { selectedWorkspace, user, dynamicCRMField } = useSelector((state: RootState) => state.common);
  const [queryText, setQueryText] = useState<string>('');
  const [fetching, setFetching] = useState<boolean>(false);
  const [isNew, setIsNew] = useState<boolean>(true);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [threadList, setThreadList] = useState<Thread[]>([]);
  const [threadListLoading, setThreadListLoading] = useState<boolean>(false);
  const [selectedThreadId, setSelectedThreadId] = useState<string>();
  const [thread, setThread] = useState<ThreadDetail[]>();
  const [threadLoading, setThreadLoading] = useState<boolean>(false);
  const [threadLimit, setThreadLimit] = useState<number>();
  const pollingRef = useRef<number>();
  const shouldNotFetchRef = useRef<boolean>(false);

  const { showSnackbar } = useSnackbar();

  const handleQueryFldOnChange = (e: ChangeEvent<HTMLInputElement>) => setQueryText(e.target.value);

  const handleQueryFldOnKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleQuery();
    }
  }

  const handleQuery = async () => {
    try {
      setFetching(true);
      const id = selectedThreadId || uuidv4();
      const payload: ThreadDetail = {
        qid: id,
        query: queryText,
        final_answer: '',
        completed_at: null
      };
      const newThread = [...thread, payload];
      const filtersObj = {
        ...filters,
        ...(!asPath.includes('admin') ? { assigned_user_ids: [user.id] } : {})
      }
      await CortexService.postQuery(selectedWorkspace?.[0]?.id, id, { query: queryText, filters: filtersObj });
      setIsNew(false);
      setQueryText('');
      setThread(newThread);
      if (!selectedThreadId) {
        shouldNotFetchDetails(true);
        setSelectedThreadId(id);
        setTimeout(() => {
          fetchThreadList();
        }, 100);
      } else {
        setTimeout(() => {
          const elm = document.querySelector(`#query_${thread.length + 1}_sys_msg`);
          if (elm) {
            elm.scrollIntoView({ block: 'end', behavior: "smooth"})
          }
        }, 200);
      }
      setTimeout(() => {
        startPolling(id);
      }, 200)
    } catch (error) {
      console.log(error);
      showSnackbar({
        type: 'error',
        message: 'There was some issue processing your request. Please try again'
      })
    } finally {
      setFetching(false);
    }
  }

  const startPolling = (id: string) => {
    stopPolling();
    pollingRef.current = window.setInterval(() => {
      fetchThreadDetail(id, true);
    }, 20000)
  }

  const stopPolling = () => {
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
    }
  }

  const shouldNotFetchDetails = (val: boolean) => {
    shouldNotFetchRef.current = val;
  }

  const fetchThreadList = async () => {
    try {
      setThreadListLoading(true);
      const response = await CortexService.getThreadList(selectedWorkspace?.[0]?.id);
      const data = response?.data?.data;
      setThreadList(data);
      if (selectedThreadId && data?.length) {
        const threadData = data.filter(thr => thr.id === selectedThreadId);
        if (threadData?.[0]?.id) {
          setSelectedThreadId(threadData?.[0]?.id);
        } else {
          setSelectedThreadId(undefined);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setThreadListLoading(false);
    }
  }

  const fetchThreadDetail = async (id?: string, isPolling: boolean = false) => {
    try {
      setThreadLoading(!id );
      const response = await CortexService.getThreadDetails(id || selectedThreadId);
      const data = response?.data?.data;
      setThread(data || []);

      const isIncomplete = (data || []).some((query) => !query.completed_at);
      if (isIncomplete) {
        startPolling(id || selectedThreadId);
      } else {
        stopPolling();
      }
      if (data?.[0]?.filters && Object.keys(filters)?.length && !isPolling) {
        const mappedData = mapCrmAdditionalFields(data, dynamicCRMField);
        handleThreadFiltersApply(mappedData?.[0]?.filters);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setThreadLoading(false);
    }
  }

  const handleNewQueryClick = () => {
    stopPolling();
    setIsNew(true);
    setThread([]);
    setSelectedThreadId(undefined);
  }

  useEffect(() => {
    if (thread?.length)
      setIsNew(false);
    else
      setIsNew(true);
  }, [thread]);

  useEffect(() => {
    if (shouldNotFetchRef.current) {
      shouldNotFetchDetails(false);
      return;
    }
    if (selectedThreadId) {
      fetchThreadDetail();
      setIsNew(false);
    } else {
      setThread([]);
      setIsNew(true);
    }
  }, [selectedThreadId]);

  useEffect(() => {
    fetchThreadList();
    setThreadLimit(user?.organisation?.feature_flags?.org_thread_limit ?? 50);
    return () => {
      stopPolling();
    }
  }, []);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent
        side="right"
        className="bg-white top-0 bottom-0 h-auto flex flex-col gap-0 w-[50%] !max-w-[640px] rounded-l-[16px] p-4 outline-none"
        closeButtonCls='text-primary-dark mt-1.5'
      >
        <SheetHeader className={`flex items-center p-0 m-0 gap-4 flex-row space-y-0 ${menuOpen ? 'invisible' : 'visible'}`}>
          <Button
            variant="outline"
            className="w-6 h-6 border-none text-primary-dark p-0 items-center justify-center"
            onClick={() => setMenuOpen(true)}
          >
            <Menu />
          </Button>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="secondary"
                  className="bg-[#F8FAFC] hover:bg-[#F8FAFC] border border-[#E2E8F0] rounded-lg gap-2 px-2 py-1 font-bold text-xs text-primary-dark h-8 disabled:pointer-events-auto"
                  onClick={handleNewQueryClick}
                  disabled={threadList?.length >= threadLimit}
                >
                  <Plus className="w-4 h-4" />
                  New Query
                </Button>
              </TooltipTrigger>
              {threadList?.length >= threadLimit && (
                <TooltipContent
                  align="center"
                  side='right'
                  className='w-[220px] bg-black p-2.5 rounded-lg text-xs font-bold text-white whitespace-normal'
                >
                  {threadList?.length >= threadLimit ? 'You have exhausted your limits for the beta access to our query engine' : ''}
                </TooltipContent>
              )}
            </Tooltip>
          </TooltipProvider>
        </SheetHeader>
        <div className="h-full mt-3 flex flex-col relative justify-end overflow-y-auto">
          {isNew ? (
            <div className="flex-1" />
          ) : (
            <ChatInterface
              thread={thread}
              loading={threadLoading}
            />
          )}
          <div className="sticky bottom-0 w-full">
            {isNew && (
              <div className="w-full flex flex-col gap-2 mt-auto">
                <div className="flex items-center gap-2 text-[#878787] font-bold">
                  <LightbulbIcon />
                  Suggestions
                </div>
                <div
                  className={`suggestion-cnt flex items-center gap-4 text-xs text-[#1C1C1C] overflow-x-auto ${
                    fetching ? 'pointer-events-none' : 'pointer-events-auto'
                  }`}
                >
                  <Suggestion
                    text="What are the common concerns my customers are raising?"
                    setInputText={setQueryText}
                  />
                  <Suggestion
                    text="Which audit parameters have the lowest scores and what can be done to improve?"
                    setInputText={setQueryText}
                  />
                  <Suggestion
                    text="What are my low intent customers saying about pricing?"
                    setInputText={setQueryText}
                  />
                </div>
                <style jsx>{`
                  .suggestion-cnt {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                  }
                  .suggestion-cnt::-webkit-scrollbar {
                    display: none;
                  }
                `}</style>
              </div>
            )}
            {thread?.length >= 1 ? [] : (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div className="w-full p-0.5 pt-2">
                      <div className="relative w-full">
                        <Input
                          value={queryText}
                          className={`h-auto rounded-full pl-4 pr-12 py-4 placeholder:font-semibold focus:ring-0 relative transition-[padding] duration-300
                          focus-visible:outline-0 focus-visible:ring-2 focus-visible:ring-secondary focus-visible:ring-offset-0 border-[#CBD5E1]
                          focus:border-[#CBD5E1] shadow-[0px_4px_8px_-2px_rgba(23,23,23,0.1)] w-full text-sm`}
                          placeholder="Type Here"
                          onChange={handleQueryFldOnChange}
                          onKeyPress={handleQueryFldOnKeyDown}
                          disabled={threadList.length >= threadLimit}
                        />
                        <Button
                          variant="outline"
                          className="bg-primary w-10 h-10 rounded-full border border-[#E2E8F0]
                          absolute top-1/2 right-1.5 p-0 flex items-center justify-center -translate-y-1/2"
                          onClick={handleQuery}
                          disabled={fetching || (threadList.length >= threadLimit)}
                        >
                          {fetching ? <Loader2 className="text-white animate-spin" /> : <ArrowUpIcon className="text-white"/>}
                        </Button>
                      </div>
                    </div>
                  </TooltipTrigger>
                  {threadList.length >= threadLimit && (
                    <TooltipContent
                      align="start"
                      side='top'
                      className='w-[220px] bg-black p-2.5 rounded-lg text-xs font-bold text-white whitespace-normal'
                    >
                      {threadList.length >= threadLimit ? 'You have exhausted your limits for the beta access to our query engine' : ''}
                    </TooltipContent>
                  )}
                </Tooltip>
              </TooltipProvider>
            )}
          </div>
        </div>
        {menuOpen && (
          <LeftPanelSheet
            open={menuOpen}
            list={threadList}
            loading={threadListLoading}
            selected={selectedThreadId}
            threadLimit={threadLimit}
            setOpen={setMenuOpen}
            setSelected={setSelectedThreadId}
            fetchThreadList={fetchThreadList}
            setIsNew={setIsNew}
            handleNewQueryClick={handleNewQueryClick}
          />
        )}
      </SheetContent>
    </Sheet>
  )
}

type SuggestionProps = {
  text: string;
  setInputText: (text: string) => void
}

const Suggestion = ({ text, setInputText }: SuggestionProps) => {
  const handleSuggestionClick = () => setInputText(text);
  return (
    <div
      className="w-full bg-[#F8FAFC] border border-[#E2E8F0] flex p-2 rounded-lg min-h-[96px] min-w-[120px] h-full cursor-pointer font-medium"
      onClick={handleSuggestionClick}
    >
      {text}
    </div>
  )
}

type Thread = {
  id: string;
  title: string;
}

type LeftPanelSheetProps = {
  open: boolean;
  list: Thread[];
  loading: boolean;
  selected: string;
  threadLimit: number;
  setOpen: (val: boolean) => void;
  fetchThreadList: () => void;
  setSelected: (val: string) => void;
  setIsNew: (val: boolean) => void;
  handleNewQueryClick: () => void;
}

const LeftPanelSheet = ({ open, setOpen, list, loading, fetchThreadList, setIsNew, threadLimit, handleNewQueryClick, ...rest }: LeftPanelSheetProps) => {

  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<string>('');
  const [deleting, setDeleting] = useState<boolean>(false);

  const handleThreadDelete = (id: string) => {
    setDeleteId(id);
    setDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      setDeleting(true);
      setDeleteId('');
      await CortexService.deleteThread(deleteId);
      fetchThreadList();
      rest.setSelected(undefined);
      setIsNew(true);
    } catch (error) {
      console.log(error)
    } finally {
      setDeleting(false);
    }
  }

  const handleNewQueryClickSheet = () => {
    setOpen(false);
    handleNewQueryClick();
  }

  const SkeletonLoader = () => {
    return (
      <div className="w-full flex flex-col gap-2 mt-4">
        <Skeleton className="h-10 rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7] mx-4" />
        <Skeleton className="h-10 rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7] mx-4" />
        <Skeleton className="h-10 rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7] mx-4" />
        <Skeleton className="h-10 rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7] mx-4" />
      </div>
    )
  }

  return (
    <>
      <div className={`${open ? 'w-full' : 'w-0'} absolute left-0 top-0 h-full bg-transparent`} onClick={() => setOpen(false)}/>
      <div
        className={`${!open ? 'animate-out fade-out-0 slide-out-to-left-4' : 'animate-in fade-in-0 slide-in-from-left-4'}
        inset-y-0 absolute top-0 left-0 w-[50%] max-w-[360px] h-full bg-white shadow-lg border rounded-[16px] transition-all
        duration-500`}
      >
        <div className="h-full flex flex-col">
          <div className="flex items-center gap-4 flex-row p-4">
            <Button
              variant="outline"
              className="w-6 h-6 border-none text-primary-dark p-0 items-center justify-center"
              onClick={() => setOpen(false)}
            >
              <Menu />
            </Button>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button
                    variant="secondary"
                    className="bg-[#F8FAFC] hover:bg-[#F8FAFC] border border-[#E2E8F0] rounded-lg gap-2 px-2 py-1 font-bold text-xs text-primary-dark h-8 disabled:pointer-events-auto"
                    disabled={list?.length >= threadLimit}
                    onClick={handleNewQueryClickSheet}
                  >
                    <Plus className="w-4 h-4" />
                    New Query
                  </Button>
                </TooltipTrigger>
                {list?.length >= threadLimit && (
                  <TooltipContent
                    align="center"
                    side='right'
                    className='w-[220px] bg-black p-2.5 rounded-lg text-xs font-bold text-white whitespace-normal'
                  >
                    {list?.length >= threadLimit ? 'You have exhausted your limits for the beta access to our query engine' : ''}
                  </TooltipContent>
                )}
              </Tooltip>
            </TooltipProvider>
          </div>
          <div className="flex flex-col flex-1 overflow-y-auto">
            <span className="text-sm text-[#878787] px-4 py-1">All threads</span>
            {Boolean(list?.length) && (
              <>
                {loading ? (
                  <SkeletonLoader />
                ) : (
                  <ul className="flex-1 overflow-y-auto">
                    {list.map(thread => (
                      <ThreadItem
                        key={thread.id}
                        setOpen={setOpen}
                        handleThreadDelete={handleThreadDelete}
                        {...thread}
                        {...rest}
                      />
                    ))}
                  </ul>
                )}
              </>
            )}
          </div>
          <div className="bg-[#F8FAFC] rounded-lg p-2 text-sm font-medium flex items-start gap-1 m-3">
            <BadgeInfoIcon className="rotate-180 min-w-[24px]" />
            You are eligible for 50 free queries per month across your organisation.
          </div>
        </div>
      </div>
      <DeleteThreadModal
        open={deleteModalOpen}
        setOpen={setDeleteModalOpen}
        handleDeleteConfirm={handleDeleteConfirm}
        setDeleteId={setDeleteId}
        loading={deleting}
      />
    </>
  )
}

type ThreadItemProps = Thread & {
  selected: string;
  setOpen: (val: boolean) => void;
  setSelected: (val: string) => void;
  handleThreadDelete: (id: string) => void;
}

const ThreadItem = ({ id, title, selected, setSelected, setOpen, handleThreadDelete }: ThreadItemProps) => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const handleItemClick = () => {
    setSelected(id);
    setOpen(false);
  };

  const handleDeleteItemClick = (e) => {
    e.stopPropagation()
    handleThreadDelete(id);
  }

  return (
    <li
      className={`h-12 px-4 py-3 text-sm font-medium cursor-pointer flex items-center group hover:bg-[#F7F9FB] pointer-events-auto
        ${selected === id ? 'bg-[#F7F9FB]' : 'bg-white'}
      `}
      title={title}
      onClick={handleItemClick}
    >
      <span className="w-full truncate block">{title}</span>
      <DropdownMenu modal={false} open={menuOpen} onOpenChange={setMenuOpen} >
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            className={`hidden w-fit h-fit rounded-md bg-transparent border-none group-hover:block p-0 ${menuOpen ? 'block' : ''}`}
            onClick={(e) => e.stopPropagation()}
          >
            <EllipsisIcon />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="start"
          side='bottom'
          className='w-[200px] bg-[#F8FAFC] max-h-[130px] p-0 py-1 rounded-xl
          border-[#E2E8F0] data-[state=closed]:hidden pointer-events-auto'
        >
          {/* <DropdownMenuItem
            className='flex items-center gap-2.5 px-3 py-2 w-full hover:bg-[#E2E8F0] cursor-pointer'
          >
            <PencilIcon className="w-5 h-5" />
            <span className="text-sm">Rename</span>
          </DropdownMenuItem> */}
          <DropdownMenuItem
            className='flex items-center gap-2.5 px-3 py-2 w-full hover:bg-[#E2E8F0] cursor-pointer text-negative-red'
            onClick={handleDeleteItemClick}
          >
            <Trash2Icon className="w-5 h-5" />
            <span className="text-sm">Delete</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </li>
  )
}

type ChatInterfaceProps = {
  thread: ThreadDetail[];
  loading: boolean;
}

const ChatInterface = ({ thread, loading }: ChatInterfaceProps) => {

  const SkeletonLoader = () => {
    return (
      <div className="w-full flex flex-col gap-2 mt-auto">
        <div className="flex items-center gap-6 mb-6 justify-end">
          <Skeleton className="h-14 w-[80%] rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
          <Skeleton className="h-7 w-7 rounded-full bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
        </div>
        <div className="flex items-center gap-6 mb-6">
          <Skeleton className="h-7 w-7 rounded-full bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
          <Skeleton className="h-28 w-[80%] rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
        </div>
        <div className="flex items-center gap-6 mb-6 justify-end">
          <Skeleton className="h-10 w-[80%] rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
          <Skeleton className="h-7 w-7 rounded-full bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
        </div>
        <div className="flex items-center gap-6">
          <Skeleton className="h-7 w-7 rounded-full bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
          <Skeleton className="h-20 w-[80%] rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
        </div>
      </div>
    )
  }

  return (
    <div className="h-full flex flex-col overflow-y-auto mt-auto">
      {loading ? (
        <SkeletonLoader />
      ) : (
        <>
          {Boolean(thread?.length) && (
            <div id="scroll" className="w-full flex flex-col overflow-y-auto px-1.5 mt-auto">
              <div className="mt-auto flex flex-col">
                {thread.map((msg, idx) => (
                  <Fragment key={msg.qid}>
                    <Chat idx={idx + 1} role='user' {...msg} />
                    <Chat idx={idx + 1} role='system' {...msg} />
                  </Fragment>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  )
}

type ChatProps = ThreadDetail & {
  role: string;
  idx: number;
}

const Chat = ({ idx, role, query, final_answer, completed_at }: ChatProps) => {
  const { user } = useSelector((state: RootState) => state.common);
  return (
    <div id={role === 'user' ? `query_${idx}_user_msg` : `query_${idx}_sys_msg`} className="flex gap-4 w-full mb-6">
      <span className="min-w-[65px] h-[65px] max-h-[65px] flex items-center justify-center">
        {role === 'system' && (
          <div className="pulsating-circle relative flex items-center justify-center w-[35px] h-[35px] rounded-full">
            <img
              src="/icons/zip-vector.svg"
              className="w-[20px] h-[20px] z-[2]"
              alt="pulse"
            />
            {!final_answer && (
              <>
                <span
                  className="absolute top-0 left-0 right-0 bottom-0 rounded-full bg-secondary bg-opacity-80 w-full h-full m-0 p-0 border-1 border-[#bbe2f0]"
                />
                <span
                  className="absolute top-0 left-0 right-0 bottom-0 rounded-full bg-secondary bg-opacity-80 w-full h-full m-0 p-0 border-2 border-[#bbe2f0]"
                />
                <span
                  className="absolute top-0 left-0 right-0 bottom-0 rounded-full bg-secondary bg-opacity-80 w-full h-full m-0 p-0 border-2 border-[#bbe2f0]"
                />
                <span
                  className="absolute top-0 left-0 right-0 bottom-0 rounded-full bg-secondary bg-opacity-80 w-full h-full m-0 p-0 border-2 border-[#bbe2f0]"
                />
              </>
            )}
          </div>
        )}
        <style jsx>{`
          .pulsating-circle {
            background: linear-gradient(135.32deg,#74adc7 -5.19%,#31667f 30.47%,#14262f 108.06%);
          }
          .pulsating-circle span {
            animation: pulse 3s ease-out infinite;
          }
          .pulsating-circle span:nth-of-type(2) {
            animation: pulse 3s ease-out infinite;
            animation-delay: 1s;
          }
          .pulsating-circle span:nth-of-type(3) {
            animation: pulse 3s ease-out infinite;
            animation-delay: 2s;
          }
          .pulsating-circle span:nth-of-type(4) {
            animation: pulse 3s ease-out infinite;
            animation-delay: 3s;
          }
          @keyframes pulse {
            100% {
              transform: scale(1.85);
              opacity: 0;
            }
          }
        `}</style>
      </span>
      <div className="w-full">
        {role === 'system' ? (
          <>
            {typeof final_answer === 'string' && completed_at ? (
              <Markdown className="whitespace-pre-line [&_h1]:font-bold [&_h2]:font-bold [&_h3]:font-bold [&_h4]:font-bold [&_h5]:font-bold [&_h6]:font-bold [&_ol]:list-decimal [&_ol]:ps-[40px] [&_ul]:list-disc [&_ul]:ps-[40px]">{final_answer}</Markdown>
            ) : (
              <div className="flex flex-col gap-2">
                <ThreeDotLoader className="w-3 h-3"/>
                <div className="text-sm">Please wait, our AI is analyzing your query to deliver the best possible response.</div>
              </div>
            )}
          </>
        ) : (
          <div className="bg-[#F2F4F8] rounded-xl p-4 h-auto flex justify-end">
            {query}
          </div>
        )}
      </div>
      <span className="min-w-[30px] h-[30px] max-h-[30px]">
        {role === 'user' && (
          <img
            src={user?.avatar_url || '/icons/profile-default.svg'}
            className="rounded-full w-[30px] h-[30px] object-cover"
            alt="profile"
            onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = '/icons/profile-default.svg';
            }}
          />
        )}
      </span>
    </div>
  )
}

type ThreeDotLoaderProps = React.HTMLAttributes<HTMLDivElement>

const ThreeDotLoader = ({ className }: ThreeDotLoaderProps) => {
  const divClasses = cn('h-2 w-2 rounded-full scale-0 bg-black inline-block m-1', className);
  return (
    <>
      <div className="three-dot-loader flex my-0 flex-auto">
        <div className={`${divClasses}`} />
        <div className={`${divClasses}`} />
        <div className={`${divClasses}`} />
      </div>
      <style jsx>{`
        .three-dot-loader div {
          animation: scaling 1.5s ease-in-out infinite;
        }
        .three-dot-loader div:nth-child(1){
          animation-delay:0s;
        }
        .three-dot-loader div:nth-child(2){
          animation-delay:0.2s;
        }
        .three-dot-loader div:nth-child(3){
          animation-delay:0.4s;
        }
        @keyframes scaling{
          0%, 100%{
            transform: scale(0.2);
            background-color: #BDBDBD;
          }
          33%{
            transform: scale(1);
            background-color: #848484;
          }
          66%{
            transform: scale(1);
            background-color: #000000;
          }
        }
      `}</style>
    </>
  )
}

type DeleteThreadModalProps = {
  open: boolean;
  setOpen: (val: boolean) => void;
  loading: boolean;
  handleDeleteConfirm: () => void;
  setDeleteId: (id: string) => void;
}

const DeleteThreadModal = ({ open, setOpen, loading, handleDeleteConfirm, setDeleteId }: DeleteThreadModalProps) => {
  const handleCancelClick = () => {
    setOpen(false);
    setDeleteId('');
  }

  const handleDeleteClick = async () => {
    await handleDeleteConfirm();
    setOpen(false);
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="w-[90%] max-w-[450px] p-6 bg-white gap-0">
        <div className="text-center font-bold text-xl mx-auto mb-3">Delete Thread</div>
        <div className="text-center text-sm mb-6">This action will delete all the previous data. Are you sure you want to delete this thread?</div>
        <DialogFooter className="sm:justify-center gap-3 mb-1">
          <Button
            variant="secondary"
            className='rounded w-full bg-[#E1EBEF] hover:bg-[#E1EBEF] text-secondary'
            onClick={handleCancelClick}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="secondary"
            className='rounded w-full bg-secondary hover:bg-secondary text-white'
            onClick={handleDeleteClick}
            disabled={loading}
          >
            {loading ? <ThreeDotLoader2 /> : "Delete"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default QueryEngineSheet;
